<style lang="scss" scoped>

.spinner-border-costum {
    width: 22px;
    height: 22px;
    border-width: 3px;
}

.btn-costum {
    padding:0px;width:36px; height:36px;    
}

</style>

<template>
    <Alert type="danger" :show="alertError" :timeout="5000" >
        <template v-slot:title>{{alertErrorTitle}}</template>
        Ihr Standort konnte nicht bestimmt werden. Bitte geben Sie den Breitengrad Nord und Längengrad Ost in Dezimalschreibweise händisch an.
    </Alert>
    
    <div class="row g-2">
        <div class="col input-group">
            <imask-input type="text" v-model="latitude_" :mask="'0[0],000000'" class="form-control"
            placeholder="Breitengrad (dezimal)" />
            <imask-input type="text" v-model="longitude_" :mask="'0[0],000000'" class="form-control"
            placeholder="Längengrad (dezimal)" />
        </div>
        <div class="col-auto">
            <a href="#" class="btn btn-white btn-icon btn-costum" aria-label="Position bestimmen" @click="getGeoLocation">
                <div v-show="loading" class="spinner-border spinner-border-costum text-muted text-azure" role="status" ></div>
          
                <svg v-show="!loading" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="2 2 20 20" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <circle cx="12" cy="11" r="3" />
                    <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />            
                </svg>
            </a>
        </div>
    </div>
</template>

<script>

import { IMaskComponent } from 'vue-imask';

import Alert from '@/components/Alert.vue';

export default {
    name: 'DatePickerInput',
    components: {
        'imask-input': IMaskComponent,
        Alert
    },
    props: {
        longitude: {
            type: Number,
            default: null
        },
        latitude: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            longitude_: '',
            latitude_: '',
            loading: false,
            alertError: false,
            alertErrorTitle: ''
        }  
    },
    methods: {
        getGeoLocation: function () {
            let self = this;
            self.alertError = false;
            
            if (navigator.geolocation) {
                self.loading = true;

                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        self.longitude_ = self.floatToString(position.coords.longitude);
                        self.latitude_ = self.floatToString(position.coords.latitude);
                        self.loading = false;   
                    },
                    function (error) {
                      switch(error.code) {
                        case error.PERMISSION_DENIED:
                          self.alertErrorTitle = "Positionsbestimmung wurde abgelehnt";
                          break;
                        case error.POSITION_UNAVAILABLE:
                          self.alertErrorTitle = "Position nicht verfügbar";
                          break;
                        case error.TIMEOUT:
                          self.alertErrorTitle = "Zeitüberschreitung";
                          break;
                        case error.UNKNOWN_ERROR:
                          self.alertErrorTitle = "Unbekannter Fehler";
                          break;
                      }
                       self.$nextTick(function() { 
                            self.alertError = true;
                            self.loading = false
                       });
                    }
                );
            } else {
                self.alertErrorTitle = "Endgerät unterstützt keine Positionsbestimmung"
                self.$nextTick(function() { 
                    self.alertError = true;
                    self.loading = false
                });
            }
        },
        floatToString: function (loc) {
            return String(loc).replace('.',',');
        },
        stringToFloat: function (loc) {
            return parseFloat(String(loc).replace(',', '.'));
        }
    },    
    created: function () {
    },
    mounted: function () {
    },
    watch: {
        longitude: function (new_value, old_value) {
            if (new_value !== old_value) {
               if (new_value === null) { 
                    this.longitude_ = '';
               } else {
                    this.longitude_ = this.floatToString(new_value);
               }
            }
        },
        latitude: function (new_value, old_value) {
            if (new_value !== old_value) {
                 if (new_value === null) { 
                    this.latitude_ = '';
               } else {
                    this.latitude_ = this.floatToString(new_value);
               }
            }
        },
        longitude_: function (new_value, old_value) {
            if (new_value !==  old_value && new_value.trim() !== '') {
                this.$emit('update:longitude', this.stringToFloat(new_value));
            }
        },
        latitude_: function (new_value, old_value) {
            if (new_value !==  old_value && new_value.trim() !== '') {
                this.$emit('update:latitude', this.stringToFloat(new_value));
            }
        }
    } 
}
</script>